/**
 * Which user this page load already checked for a tour to resume (Ruling F4). The check runs one
 * time for each user and page load: after "Exit tour" a late answer of the server must not turn
 * the guide bar on again. The shell mounts again on each page, so the mark lives outside React.
 */
let checkedUserId: number | null = null;

export function wasTourResumeChecked(userId: number): boolean {
  return checkedUserId === userId;
}

export function markTourResumeChecked(userId: number): void {
  checkedUserId = userId;
}

/** Tests only. */
export function resetTourResumeCheck(): void {
  checkedUserId = null;
}
